const init = (el) => {
    const loadMoreButton = el.querySelector('[data-js-load-more]');
    const paginationItems = el.querySelectorAll('[data-js-pagination-item]');
    const paginationSize = parseInt(el.getAttribute('data-pagination-size'), 10);

    const loadMore = (event) => {
        try {
            event.preventDefault();

            const currentPage = parseInt(el.getAttribute('data-pagination-page'), 10);

            if (isNaN(currentPage)) throw new Error('Could not determine current pagination page');
            if (isNaN(paginationSize)) throw new Error('Could not determine current pagination size');

            const currentOffset = currentPage * paginationSize;
            const targetOffset = currentOffset + paginationSize;

            [...paginationItems]
                .slice(currentOffset, targetOffset)
                .forEach((paginationItem) => paginationItem.classList.remove('hidden'));

            el.setAttribute('data-pagination-page', currentPage + 1);

            if (targetOffset > paginationItems.length) {
                loadMoreButton.removeEventListener('click', loadMore);
                loadMoreButton.remove();
            }
        } catch (error) {
            console.error('Could not load more results:', error);
        }
    };

    loadMoreButton?.addEventListener('click', loadMore);
};

document.addEventListener('DOMContentLoaded', () => {
    const paginationModules = document.querySelectorAll('[data-js-module="pagination"]');

    paginationModules?.forEach((el) => init(el));
});
